import React from "react";
import CustomProject from "../CustomProject";
import "./index.css";

export default function Experience() {
  return (
        <>
      <section className="section projects">
        <div className="section-title">WORK EXPERIENCE</div>
        <div className="section-content">
          <CustomProject
            title="Riggle (Jun 2022 - Present)"
            link="https://www.riggleapp.in/"
            desc=" Riggle is digitizing the general trade supply chain for FMCG manufacturers."
            usedArray={[
              "JavaScript",
              "React",
              "AntD",
              "React Router",
              "SCSS",
            ]}
          />
        </div>
      </section>
    </>
  );
}